/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import Flex from './Flex';
export default function Row(props) {
    return jsx(Flex, Object.assign({ wrap: "wrap", sx: { marginX: '-columnGap' } }, props));
}
//# sourceMappingURL=Row.js.map